import React from 'react'
import { Navigate } from 'react-router-dom'
import { ProtectedRoute } from '../shared/ProtectedRoute'
import { useAppMode } from '../../contexts/AppModeContext'
import { useAuth } from '../../contexts/AuthContext'
import { isOnCallInDevMode } from '../../utils/onCall'
import { GlobalQueueAlerts } from '../shared/GlobalQueueAlerts'
import { TodoNotebook } from '../todo/TodoNotebook'
import { DevBoard } from './board/DevBoard'

/**
 * Dev Mode — a blank workspace. Its own minimal shell (NOT the support Layout), so
 * there's no Support/CRM sidebar, and none of the notification/ring components
 * mount → nothing rings or pops. The only control is a "Support Mode" button.
 *
 * MVP: intentionally an empty canvas — build dev tooling into <main> here.
 */
const DevModeInner: React.FC = () => {
  const { mode } = useAppMode()
  const { currentAgent } = useAuth()

  // If somehow here while in support mode (stray URL), bounce back.
  if (mode !== 'dev') return <Navigate to="/dashboard" replace />

  // On-call agents (Lee, 4 Sep): the incoming-chat ringer + pickup card stay
  // live in Dev Mode; accepting a chat shifts them to the Support side.
  const onCall = isOnCallInDevMode(currentAgent)

  return (
    <div className="flex flex-col h-screen bg-surface-secondary text-txt-primary">
      {/* The mode header is gone (Lee, 26 Aug) — the board owns the window;
          the Support Mode switch lives in the board's own top bar. */}

      {/* Dev Board (rebuild) — Phase 0 shell, server-backed. */}
      <main className="flex-1 min-h-0 overflow-hidden">
        <DevBoard />
      </main>

      {onCall && <GlobalQueueAlerts />}

      {/* Personal TO-DO notebook — the SAME per-agent list as Support Mode
          (shared localStorage key), so it's global and mode-independent. It's
          purely visual/local: no rings or notifications, so it respects Dev
          Mode's silence. */}
      <TodoNotebook />
    </div>
  )
}

export const DevMode: React.FC = () => (
  <ProtectedRoute>
    <DevModeInner />
  </ProtectedRoute>
)
